import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CASE_STUDIES } from "../mock/mock";

const PILLARS = [
  {
    title: "Strategy",
    blurb:
      "Audience, market & route planning — we map your message to the streets that matter most.",
  },
  {
    title: "Concept",
    blurb:
      "Big-idea creative tuned for OOH — minimal copy, maximum recall, on-brand always.",
  },
  {
    title: "Design",
    blurb:
      "Art direction, typography and production-ready artwork — in-house, no compromises.",
  },
  {
    title: "Production",
    blurb:
      "Print, fabrication, install and post-campaign — we handle every nail and pixel.",
  },
];

const Creative = () => {
  return (
    <main>
      <section className="relative bg-black text-white pt-40 pb-20 md:pt-48 md:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="text-[11px] uppercase tracking-[0.32em] text-white/60 mb-6">Creative</p>
          <h1 className="font-display text-[14vw] md:text-[8vw] uppercase leading-[0.92]">
            Creative <br />
            <span className="font-serif-display italic font-black">matters.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-white/75 text-lg leading-relaxed">
            Great media without great creative is just paper. Our in-house studio
            crafts work that earns the look, not just the impression.
          </p>
        </div>
      </section>

      <section className="bg-white text-black">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32 grid grid-cols-1 md:grid-cols-2 gap-y-16 gap-x-12">
          {PILLARS.map((p, i) => (
            <div key={p.title} className="border-t border-black/15 pt-8">
              <span className="text-[11px] uppercase tracking-[0.3em] text-black/45">
                0{i + 1}
              </span>
              <h3 className="font-display text-6xl md:text-7xl uppercase leading-none mt-4">
                {p.title}
              </h3>
              <p className="mt-6 text-black/70 leading-relaxed max-w-md">
                {p.blurb}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-neutral-50 text-black">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            {CASE_STUDIES.slice(0, 6).map((c) => (
              <div key={c.brand} className="relative aspect-square overflow-hidden group">
                <img
                  src={c.image}
                  alt={c.brand}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-[900ms]"
                />
                <div className="absolute bottom-3 left-3 text-white font-display text-xl uppercase">{c.brand}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-black text-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <h3 className="font-display text-[10vw] md:text-[5.6vw] uppercase leading-[0.92]">
            Brief us. <span className="font-serif-display italic font-black">today.</span>
          </h3>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 text-sm uppercase tracking-[0.22em] font-semibold px-7 py-4 border border-white hover:bg-white hover:text-black transition-colors duration-200"
          >
            Start a Brief <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Creative;
